import { render, staticRenderFns } from "./gradientColors.vue?vue&type=template&id=44d87914&scoped=true"
import script from "./gradientColors.vue?vue&type=script&lang=js"
export * from "./gradientColors.vue?vue&type=script&lang=js"
import style0 from "./gradientColors.vue?vue&type=style&index=0&id=44d87914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d87914",
  null
  
)

export default component.exports